<script>
import { mapGetters, mapActions } from "vuex";
import * as Helper from "@/modules/helper/index";
import DeviceInfo from '@/modules/util/deviceInfo';

const FORM_CONTROLS = [
  "text-input",
  "date-input",
  "time-input",
  "switch-group",
  "radio-group",
  "check-box-group",
  "picker-list",
  "calendar",
  "smart-select",
  "number-input",
  "spin-edit",
  "rating",
  "satisfaction",
  "upload"
];
export default {
  data() {
    return {
      headerName: null,
      formData: "",
      dataFlag: true
    };
  },
  computed: {
    ...mapGetters(["MainMenuLayout", "Form", "AppConfig", "resource"]),
    SubscriptionModuleId() {
      return parseInt(this.$f7route.params.Id)
    },
    Header() {
      this.headerName = Helper.IsValid(this.Form) ? this.Form.PageTitle : ""
      return this.headerName
    },
    FormFields: {
      get() {
        let formFieldsData = this.Form.FormFields
        let formFields
        if (!Helper.IsNullOrEmpty(formFieldsData)) {
          formFields = JSON.parse(formFieldsData)
        }
        return formFields
      },
      set(value) {
        this.setFormFieldsData(JSON.stringify(value))
      }
    },
    showSubmitbtn() {
      if (!Helper.IsNullOrEmpty(this.Form.FormFields)) {
        let formFields = JSON.parse(this.Form.FormFields)
        return formFields.elements.length === 0 ? false : true
      }
      return false
    }
  },
  async created() {
   await this.initFormModule(this.SubscriptionModuleId);
  },
  mounted() {
    if (this.$refs.formPage) {
      this.$refs.formPage.$on("page:reinit", (event, payload) => {
        this.initFormModule(this.SubscriptionModuleId);
      });
    }
  },
  beforeDestroy() {
    if (this.$refs.formPage) {
      this.$refs.formPage.$off("page:reinit", (event, payload) => {
        // this.initFormModule(this.SubscriptionModuleId);
      });
      this.setFormFieldsData(null)
    }
  },
  watch: {
    Form: function(formData) {
      this.formData = ''
    }
  },
  methods: {
    ...mapActions([
      "loadLocalFormData",
      "loadForm",
      "submitFrom",
      "setActiveModule",
      "setFormFieldsData"
    ]),
    async initFormModule(SubscriptionModuleId) {
      let prevRoute = []
      let prevSmart = ''
      let flag = 0
      let r =  this.$f7.views.main.router.previousRoute
      prevRoute = Object.keys(r).map((k) => r[k])
      if (prevRoute.length !== 0){
           prevSmart = prevRoute[3].includes('select')
           if(prevSmart){
             flag = 1
           }
       }
     if (flag === 0) {
      this.$showLoader()
      await this.loadLocalFormData(SubscriptionModuleId)
      this.loadForm(SubscriptionModuleId)
        .then(async () => {
          this.dataFlag = false
          await this.$nextTick()
          this.dataFlag = true
          this.$hideLoader();
          this.$RegisterPageView({
            SubscriptionModule_Id: SubscriptionModuleId,
            ContentGUID: this.Form.Id,
            ViewType: 1
          })
        })
        .catch(err => {
          console.log("err", err)
          this.$hideLoader()
        })
     }
    },
    handlePropertyChange(index, payload) {
      if (!Helper.IsNullOrEmpty(this.Form.FormFields)) {
      const element = this.FormFields.elements[index]
      let updatedElement = {
        ...element,
        properties: {
          ...element.properties,
          ...payload
        }
      };
      let updatedElements = [
        ...this.FormFields.elements.slice(0, index),
        updatedElement,
        ...this.FormFields.elements.slice(index + 1)
      ];
      this.FormFields = {
        elements: updatedElements,
        elemail: this.FormFields.elemail ? this.FormFields.elemail : null,

      };
     }
    },
    onFormSubmitClick() {
      if (Helper.IsUserActionAllow()) {
        this.$showLoader();
        if (this.formValidation()) {
          let submissionData = JSON.parse(this.Form.FormFields);
          let filteredData = submissionData.elements.filter(element =>
            FORM_CONTROLS.includes(element.elementType)
          )
            let payload = {
            Subscription_Id: this.AppConfig.Subscription_Id,
            ModulesForms_Id: this.Form.Id,
            ReportingRegisteredApps_AppGUID: this.AppConfig.AppGUID,
            SubmissionData: JSON.stringify({
              elements: filteredData
            }),
            EmailData: this.FormFields.elemail ? this.FormFields.elemail : null,
            AppGUID: this.AppConfig.AppGUID,
            NotificationContent: {
              Title: this.Form.PageTitle,
              ImageName: "",
              Comment: "",
              Navigationurl: `/custom-form-view/${this.SubscriptionModuleId}`
            }
          };
          this.submitFrom(payload)
            .then(() => {
              this.formData = "";
              this.$hideLoader();
              this.$f7.notification
                .create({
                  title: "Success",
                  subtitle: this.Form.SubmitSuccessMessage,
                  cssClass: "success-notification",
                  closeOnClick: true,
                  closeTimeout: 3000
                })
                .open();
              // this.setActiveModule("back");
              this.$f7.view.main.router.navigate('/')
            })
            .catch(err => {
              console.log("err", err);
              this.$f7.notification
                .create({
                  title: "Error",
                  subtitle: this.Form.SubmitErrorMessage,
                  cssClass: "error-notification",
                  closeOnClick: true,
                  closeTimeout: 3000
                })
                .open();
              this.$hideLoader();
            });
        } else {
          // this.$f7.alert('please fill form..', 'Custom Title!')
          this.$hideLoader();
        }
      } else {
        let modalOptions = {
          title: this.resource.warningTitle,
          text: this.resource.warningMessage,
          buttonText: this.resource.closeBtn,
          downloadbuttonText: DeviceInfo.isAndroid
            ? this.resource.AndroidDownload
            : this.resource.AppleDownload,
          $f7: this.$f7
        };
        this.$showModal(modalOptions);
      }
    },
    formValidation() {
      let flag = true
      if (!Helper.IsNullOrEmpty(this.Form.FormFields)) {
        let submissionData = JSON.parse(this.Form.FormFields)
        let updatedElementsList = submissionData;
        submissionData.elements.forEach((element, index) => {
          if (FORM_CONTROLS.includes(element.elementType)) {
            let payload;
            if (element.properties.required && Helper.IsNullOrEmpty(element.properties.value)) {
              flag = false;
              payload = {
                errorMessage:
                  "*" + element.properties.label + " "+ this.resource.errorfieldrequired,
                value: ""
              };
            } else if (element.properties.fieldType && element.properties.fieldType === "email") {
              if (!Helper.validateEmail(element.properties.value) && !Helper.IsNullOrEmpty(element.properties.value)) {
                flag = false;
                payload = {
                  errorMessage: "*" + this.resource.errorCommentMessageValidEmail,
                value: ""
                };
              } else {
                payload = {
                  errorMessage: ""
                };
              }
            } else if (element.properties.fieldType && element.properties.fieldType === "phone") {
              if (!Helper.validatePhone(element.properties.value) && !Helper.IsNullOrEmpty(element.properties.value)) {
                flag = false;
                payload = {
                  errorMessage: "*" + this.resource.errorCommentMessageValidPhone,
                  value: ""
                };
              } else {
                payload = {
                  errorMessage: ""
                };
              }
            } else if (element.properties.fieldType && element.properties.fieldType === "url") {
              if (!Helper.validateUrl(element.properties.value) && !Helper.IsNullOrEmpty(element.properties.value)) {
                flag = false;
                payload = {
                  errorMessage: "*" + this.resource.errorCommentMessageValidPhone,
                  value: ""
                };
              } else {
                payload = {
                  errorMessage: ""
                };
              }
            } else {
              payload = {
                errorMessage: ""
              };
            }
            let updatedElement = {
              ...element,
              properties: {
                ...element.properties,
                ...payload
              }
            };
            let updatedElements = [
              ...updatedElementsList.elements.slice(0, index),
              updatedElement,
              ...updatedElementsList.elements.slice(index + 1)
            ];
            updatedElementsList = {
              elements: updatedElements,
              elemail: this.FormFields.elemail ? this.FormFields.elemail : null,
            };
          }
        });

        this.FormFields = updatedElementsList;
      } else {
        flag = false;
      }
      return flag;
    }
  }
};
</script>
<template>
    <f7-page ref="formPage" :page-content="false" name="custom-form-view">
        <!-- Header View Component -->
        <app-header :header="Header"></app-header>
        <!-- Menu View Component  -->
        <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
        <!-- <app-side-menu v-if="MainMenuLayout === 2"></app-side-menu> -->
        <div class="backgroundimg"></div>
        <!-- Page content View -->
        <f7-page-content>
            <!-- <f7-block inner> -->
            <div v-if="Form" class="element-section">
                <template v-if="dataFlag && FormFields">
                    <component v-for="(el,index) in FormFields.elements" :is="'app-' + el.elementType" :key="index" :index="index" v-bind="el.properties" @propChange="handlePropertyChange(index, $event)">
                    </component>
                </template>
                <div class="bottomspace">
                   <f7-button big fill :outline="true" @click="onFormSubmitClick()" :disabled="!showSubmitbtn">{{Form.SubmitButtonLabel}}</f7-button>
               </div>
            </div>
        </f7-page-content>
    </f7-page>
</template>
<style scoped>
.bottomspace{
  padding:22px;
  margin: 0px;
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-form/CustomForm.vue